/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ChangeStatusRequestViewModel } from "../types/ChangeStatusRequestViewModel.ts";
import { eClassRoomDisciplinesStatusSchema } from "./eClassRoomDisciplinesStatusSchema.ts";

export const changeStatusRequestViewModelSchema = z.object({
  status: z.optional(
    z
      .lazy(() => eClassRoomDisciplinesStatusSchema)
      .describe("1 = Planned | 2 = Finished | 3 = Canceled | 4 = Confirmed | "),
  ),
  disciplineId: z.number().int().nullish(),
}) as unknown as ToZod<ChangeStatusRequestViewModel>;
